"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var basedecoder_js_1 = __importDefault(require("./basedecoder.js"));

var PackbitsDecoder = /*#__PURE__*/function (_basedecoder_js_1$def) {
  (0, _inherits2.default)(PackbitsDecoder, _basedecoder_js_1$def);

  var _super = _createSuper(PackbitsDecoder);

  function PackbitsDecoder() {
    (0, _classCallCheck2.default)(this, PackbitsDecoder);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PackbitsDecoder, [{
    key: "decodeBlock",
    value: function decodeBlock(buffer) {
      var dataView = new DataView(buffer);
      var out = [];

      for (var i = 0; i < buffer.byteLength; ++i) {
        var header = dataView.getInt8(i);

        if (header < 0) {
          var next = dataView.getUint8(i + 1);
          header = -header;

          for (var j = 0; j <= header; ++j) {
            out.push(next);
          }

          i += 1;
        } else {
          for (var _j = 0; _j <= header; ++_j) {
            out.push(dataView.getUint8(i + _j + 1));
          }

          i += header + 1;
        }
      }

      return new Uint8Array(out).buffer;
    }
  }]);
  return PackbitsDecoder;
}(basedecoder_js_1.default);

exports.default = PackbitsDecoder;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztJQUVxQkEsZTs7Ozs7Ozs7Ozs7O1dBQ25CLHFCQUFZQyxNQUFaLEVBQWtCO01BQ2hCLElBQU1DLFFBQVEsR0FBRyxJQUFJQyxRQUFKLENBQWFGLE1BQWIsQ0FBakI7TUFDQSxJQUFNRyxHQUFHLEdBQUcsRUFBWjs7TUFFQSxLQUFLLElBQUlDLENBQUMsR0FBRyxDQUFiLEVBQWdCQSxDQUFDLEdBQUdKLE1BQU0sQ0FBQ0ssVUFBM0IsRUFBdUMsRUFBRUQsQ0FBekMsRUFBNEM7UUFDMUMsSUFBSUUsTUFBTSxHQUFHTCxRQUFRLENBQUNNLE9BQVQsQ0FBaUJILENBQWpCLENBQWI7O1FBQ0EsSUFBSUUsTUFBTSxHQUFHLENBQWIsRUFBZ0I7VUFDZCxJQUFNRSxJQUFJLEdBQUdQLFFBQVEsQ0FBQ1EsUUFBVCxDQUFrQkwsQ0FBQyxHQUFHLENBQXRCLENBQWI7VUFDQUUsTUFBTSxHQUFHLENBQUNBLE1BQVY7O1VBQ0EsS0FBSyxJQUFJSSxDQUFDLEdBQUcsQ0FBYixFQUFnQkEsQ0FBQyxJQUFJSixNQUFyQixFQUE2QixFQUFFSSxDQUEvQixFQUFrQztZQUNoQ1AsR0FBRyxDQUFDUSxJQUFKLENBQVNILElBQVQ7VUFDRDs7VUFDREosQ0FBQyxJQUFJLENBQUw7UUFDRCxDQVBELE1BT087VUFDTCxLQUFLLElBQUlNLEVBQUMsR0FBRyxDQUFiLEVBQWdCQSxFQUFDLElBQUlKLE1BQXJCLEVBQTZCLEVBQUVJLEVBQS9CLEVBQWtDO1lBQ2hDUCxHQUFHLENBQUNRLElBQUosQ0FBU1YsUUFBUSxDQUFDUSxRQUFULENBQWtCTCxDQUFDLEdBQUdNLEVBQUosR0FBUSxDQUExQixDQUFUO1VBQ0Q7O1VBQ0ROLENBQUMsSUFBSUUsTUFBTSxHQUFHLENBQWQ7UUFDRDtNQUNGOztNQUNELE9BQU8sSUFBSU0sVUFBSixDQUFlVCxHQUFmLEVBQW9CSCxNQUEzQjtJQUNEOzs7RUF0QjBDYSx3Qjs7QUFBN0NDIiwibmFtZXMiOlsiUGFja2JpdHNEZWNvZGVyIiwiYnVmZmVyIiwiZGF0YVZpZXciLCJEYXRhVmlldyIsIm91dCIsImkiLCJieXRlTGVuZ3RoIiwiaGVhZGVyIiwiZ2V0SW50OCIsIm5leHQiLCJnZXRVaW50OCIsImoiLCJwdXNoIiwiVWludDhBcnJheSIsImJhc2VkZWNvZGVyX2pzXzEiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2Rpc3QtbW9kdWxlL2NvbXByZXNzaW9uL3BhY2tiaXRzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19